export const ExcelColumn = [
    "BuyerStyle",
    "BuyerCode",
    "BuyerAddress",
    // "Earliestexfty",
    // "DeliveryDateHeader",
    "EarliestexftyDD/MM/YYYY",
    "DeliveryDateHeaderDD/MM/YYYY",
    "Deliveryaddress",
    "Itemdescription",
    "Orderqty",
    "Salesprice",
    "Currency",
    "SampleItemNo",
    "Dis%Item",
    // "Earliestexfty",
    "BuyerPO",




]